// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@5.90.3/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selfdefine-card[data-v-62d25f2e] {\n  margin: 16px 0;\n}\n", ""]);
// Exports
module.exports = exports;
